import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Hero.css';
import Services from '../components/common/Services';
import WhatYouGet from './WhatYouGet';  // ← FIXED: removed 'components/' since you're already in the components folder

const Home = () => {
  const navigate = useNavigate();

  const heroStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL + '/images/hero/hero-background.jpg'})`,
  };

  return (
    <>
      {/* Hero Section */}
      <section className="hero" style={heroStyle}>
        <div className="hero-overlay">
          <div className="hero-content">
            <h1 className="hero-title">Become a Ripple of Influence.</h1>
            <p className="hero-subtitle">- Rippluence</p>
            <div className="hero-buttons">
              <button className="btn-primary" onClick={() => navigate('/contact')}>Grow With Us</button>
            </div>
          </div>
        </div>
      </section>

      {/* What You Get Section - Add this after Hero, before Services */}
      <WhatYouGet />

      {/* Services Section */}
      <Services />
    </>
  );
};

export default Home;